import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/_basic-layout/account')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/account' as string });
  },
});
